<div class="ap-cr-grid">
  <div class="ap-cr-headers">
    <ap-crop-rotation-header [nameText]="'Base__ManagementStyle_Fieldname' | translate"
                             [numberText]="'Docu_Ini__Number' | translate"
                             [subNumberText]="'Global__FieldPartShort' | translate"
                             [areaText]="'Unit_ha' | translate"
                             [availableCropTypes]="availableCropTypes"
                             [allCropTypes]="allCropTypes"
                             [currentYear]="currentYear"
                             [(yearInterval)]="yearInterval"
                             [columnWidth]="columnWidth"
                             [selectedFields]="selectedFields"
                             (selectedFieldsChange)="onSelectionChange($event)"
                             [fields]="itemView"
                             [fullItems]="fullItems"
                             [filteredAndSortedItems]="itemsFilteredNoPaging"
                             (sortChange)="onSort($event)"
                             [filter]="filter"
                             (filterChange)="onFilter($event)"
    ></ap-crop-rotation-header>
  </div>
  <div class="ap-cr-data" #dataWrapper
       [@resizeDataHeight]="currentMultiSelect">
    <ap-crop-rotation-list [fields]="itemView"
                           [loading]="loading"
                           [yearInterval]="yearInterval"
                           [currentYear]="currentYear"
                           [availableCropTypes]="availableCropTypes"
                           [columnWidth]="columnWidth"
                           [saving]="saving"
                           [selectedFields]="selectedFields"
                           [numericRound]="numericRound"
                           [wrapperHeight]="dataWrapperHeight"
                           (selectedFieldsChange)="onSelectionChange($event)"
                           (saveCell)="saveCell.emit($event)"
                           (getFocus)="getFocus.emit($event)"
                           (lostFocus)="lostFocus.emit($event)"
    ></ap-crop-rotation-list>
  </div>
  <div class="k-pager k-grid-pager k-pager-md k-widget ng-star-inserted">
    <ap-crop-rotation-grid-pager #pager
                   [selectedKeys]="selectedFields"
                   [pageSize]="pageSize"
                   [itemCount]="itemsFilteredNoPaging?.length"
                   [currentPage]="currentPage"
                   [formConfig]="formConfig"
                   [formValidators]="formValidators"
                   (currentPageChange)="onPageChange($event)"
                   [showOnlyValues]="false"
                   [showDefaultValue]="false"
                   [values]="values"
                   [objects]="listMassEditing$"
                   [preselect]="false"
                   (pageSizeChanged)="onPageSizeChanged($event)"
                   (applyClicked)="onMassEditApply($event)"
                   (formValueChanges)="onFormValueChanges($event)"
                   (startMultiSelectInAnimation)="currentMultiSelect = 'in'"
                   (startMultiSelectOutAnimation)="currentMultiSelect = 'out'"
                   (selectedColumnChange)="onMultiSelectionChange($event)"
    ></ap-crop-rotation-grid-pager>
  </div>
</div>
